export const SectionEyebrow = ({ index, label, light = false }) => (
  <div data-testid="section-eyebrow" className="flex items-center gap-5 mb-10">
    <span className="w-1.5 h-1.5 bg-onix-blue shrink-0" aria-hidden="true" />
    <span className={`eyebrow ${light ? "!text-[#050505]" : ""}`}>
      {index} <span aria-hidden="true">/</span> {label}
    </span>
    <span className={`hairline flex-1 max-w-[120px] ${light ? "!bg-[rgba(5,5,5,0.18)]" : ""}`} aria-hidden="true" />
  </div>
);
